<template>
  <div class="fragment">
    <div
      class="fragment-content"
      v-html="getContent(slotName)"
    />
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';

export default {
  name: 'Fragment',

  props: {
    slotName: {
      type: String,
      required: true
    },

    prefetch: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    ...mapGetters({
      getContent: 'staticPages/fragments'
    })
  },

  created() {
    if (!this.$isServer && !this.prefetch) this.LOAD_FRAGMENT({slotName: this.slotName});
  },

  methods: {
    ...mapActions({
      LOAD_FRAGMENT: 'staticPages/loadStaticFragments'
    })
  },

  serverPrefetch() {
    if (this.prefetch) return this.LOAD_FRAGMENT({slotName: this.slotName});
  }
};
</script>